/* ==========================================================================
   SearcherPackagesFerry > Calendar
   ========================================================================== */

/* Modules */
const CalendarClient = require('@bluekiri/alexandria-contrib-components/components/calendar/client/js');
const transactions = require('./transactions');
const calendarHelper = require('../../../../helpers/calendar');
const panel = require('./panel');
const helpers = require('../../../../helpers/calendar');

const storedOperatives = {};

function initCalendar(selector, instance) {
    const result = instance;
    const config = {
        fp: {
            ariaDateFormat: 'Y/m/d',
            minDate: new Date().fp_incr(2),

            // eslint-disable-next-line max-params
            onDayCreate: (dObj, dStr, fp, dayElem) => {
                if (instance.config.disableDays.find(item => item === dayElem.getAttribute('aria-label')))
                    dayElem.classList.add('flatpickr-disabled', 'disabled');
            }
        },
        onChange: [
            function fn() {
                const selectedDay = this.fp.selectedDateElem;
                // disabled day, you can't select the same date departure than return
                selectedDay.classList.add('disabled');
                selectedDay.blur();

                return disableCalendarDates(instance);
            }
        ]
    };
    const calendar = CalendarClient(selector, config);
    calendarHelper.setDefaultDates(instance, calendar);
    calendar.fp.config.onMonthChange = [
        function fn() {
            return disableCalendarDates(instance);
        }
    ];

    calendar.input.set(calendar.input.get());
    calendar.currentDates = calendar.get();
    calendar.fp.config.onClose = [
        () => {
            if (calendar.get().length === 0 || calendar.get().length === 1) {
                calendar.input.setActive();
                calendar.setDate(calendar.currentDates);
            }

            calendar.currentDates = calendar.get();
        }
    ];
    result.calendar = calendar;

    disableCalendarDates(result);
}

function getRouteData(instance) {
    const operative = retrieveCachedOperative(instance);
    if (operative === undefined) {
        transactions.getRouteData(instance, storeCachedOperative);
    } else {
        helpers.setFirstAvailableDates(instance, {
            retrieveCachedOperative,
            getFilteredDates,
            getParsedDates
        });
        disableCalendarDates(instance);
        panel.refreshDiscounts(operative, instance);
    }
}

function storeCachedOperative(rs, instance) {
    storedOperatives[getLocationsKey(instance.location)] = rs;
    const event = CustomEvent('loadOperative', {
        detail: {
            instance
        }
    });
    document.dispatchEvent(event);
}

document.addEventListener('loadOperative', e => {
    helpers.setFirstAvailableDates(e.detail.instance, {
        retrieveCachedOperative,
        getFilteredDates,
        getParsedDates
    });
    disableCalendarDates(e.detail.instance);
    panel.refreshDiscounts(retrieveCachedOperative(e.detail.instance), e.detail.instance);
});

function retrieveCachedOperative(instance) {
    return storedOperatives[getLocationsKey(instance.location)];
}

function getLocationsKey(locations) {
    return `${locations[0].value}#${locations[1].value}`;
}

function isCalendarFirstClick(instance) {
    return instance.calendar.get().length === 1;
}

function disableCalendarDates(instance) {
    const rsData = retrieveCachedOperative(instance);
    if (rsData !== undefined) {
        if (isCalendarFirstClick(instance) && rsData.return_dates.length > 0) {
            disableDates(getActiveDays(rsData.return_dates), instance.calendar.element, instance);
        } else if (rsData.outbound_dates.length > 0) {
            disableDates(getActiveDays(rsData.outbound_dates), instance.calendar.element, instance);
        }
    }
}

function disableDates(activeDays, calendarElement, instance) {
    const dayContainers = calendarElement.getElementsByClassName('dayContainer');
    for (let i = 0; i < dayContainers.length; i++) {
        const dayContainer = dayContainers[i];
        const flatpickrDays = dayContainer.getElementsByClassName('flatpickr-day');
        for (let j = 0; j < flatpickrDays.length; j++) {
            const flatpickrDay = flatpickrDays[j];
            if (!searchDateInDates(activeDays, flatpickrDay.dateObj)) {
                flatpickrDay.classList.add('flatpickr-disabled', 'disabled');
            } else {
                let today = new Date();
                let tomorrow = new Date();
                tomorrow.setDate(today.getDate() + 1);
                today = instance.calendar.fp.formatDate(today, instance.calendar.fp.config.altFormat);
                tomorrow = instance.calendar.fp.formatDate(tomorrow, instance.calendar.fp.config.altFormat);

                if (
                    flatpickrDay.getAttribute('aria-label') !== today &&
                    flatpickrDay.getAttribute('aria-label') !== tomorrow
                )
                    flatpickrDay.classList.remove('flatpickr-disabled', 'disabled');
            }

            if (instance.config.disableDays.find(item => item === flatpickrDay.getAttribute('aria-label')))
                flatpickrDay.classList.add('flatpickr-disabled', 'disabled');
        }
    }
}

function searchDateInDates(dates, date) {
    for (let i = 0; i < dates.length; i++) {
        const dateCol = dates[i];
        dateCol.setHours(0);
        if (dateCol.getTime() === date.getTime()) {
            return true;
        }
    }
    return false;
}

function getActiveDays(dates) {
    const arDates = [];
    const firstDate = new Date(dates[0].value);
    for (let i = 0; i < dates.length; i++) {
        const date = dates[i];
        const pDate = new Date(date.value);
        arDates.push(pDate);
    }

    const lastDate = new Date(dates[dates.length - 1].value);

    // Calculate days between first date and last date
    const milisDiff = lastDate.getTime() - firstDate.getTime();
    const daysDiff = 365 - milisDiff / 1000 / 60 / 60 / 24;

    // Calculate milis for a single day
    const milisDay = 60 * 24 * 60 * 1000;

    // Open dates after the last one from operative
    for (let i = 0; i < daysDiff; i++) {
        const newDate = new Date(lastDate.getTime());
        newDate.setMilliseconds(milisDay * (i + 1));
        arDates.push(newDate);
    }

    return arDates;
}

function getFilteredDates(flatpickrDates, operative) {
    if (operative !== undefined) {
        const arDatesOut = operative.outbound_dates.filter(date =>
            compareDates(date.value, flatpickrDates.outboundDate)
        );
        const arDatesRet = operative.return_dates.filter(date => compareDates(date.value, flatpickrDates.returnDate));
        return {
            arDatesOut,
            arDatesRet
        };
    }
    return {};
}

function compareDates(date, compareDate) {
    return new Date(Date.parse(date)).getTime() >= new Date(Date.parse(compareDate)).getTime();
}

function getParsedDates(arDatesOut, arDatesRet) {
    const outboundDate = new Date(Date.parse(arDatesOut[0].value));
    const returnDate = new Date(Date.parse(arDatesRet[0].value));
    return {
        outboundDate,
        returnDate
    };
}

module.exports = {
    initCalendar,
    disableCalendarDates,
    getRouteData
};
